import { keyEmptyCheck } from 'aurora-utils/utils';

export const PAGE_SIZE = 5;

export const REQUIRED_FIELDS = {
  UAE_RESIDENT: ['idn', 'dob'],
  COMPANY: ['tradeLicenseNo'],
  NON_UAE_RESIDENT: ['nationality', 'Passport_number'],
  GOVERNMENT_ENTITY: [],
};

export const getTypeFields = isSecondParty =>
  isSecondParty
    ? [
        {
          label: keyEmptyCheck('uae_residents'),
          value: 'UAE_RESIDENT',
        },
      ]
    : [
        {
          label: keyEmptyCheck('uae_residents'),
          value: 'UAE_RESIDENT',
        },
        {
          label: keyEmptyCheck('Company'),
          value: 'COMPANY',
        },
        {
          label: keyEmptyCheck('non_uae_residents'),
          value: 'NON_UAE_RESIDENT',
        },
        {
          label: keyEmptyCheck('GOVERNMENT'),
          value: 'GOVERNMENT_ENTITY',
        },
      ];
